import { useState } from "react";
import { FiChevronLeft, FiChevronRight, FiX } from "react-icons/fi";

const ProductImageGallery = ({ images }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isFullScreen, setIsFullScreen] = useState(false);

  // Fixed aspect ratio (e.g., 1:1 for square, 4:3, etc.)
  const aspectRatio = "aspect-[4/3]"; // Tailwind CSS aspect-ratio (width/height)
  const thumbnailRatio = "aspect-square"; // Square thumbnails

  const nextImage = () => {
    setCurrentImageIndex((prev) => (prev < images.length - 1 ? prev + 1 : 0));
  };

  const prevImage = () => {
    setCurrentImageIndex((prev) => (prev > 0 ? prev - 1 : images.length - 1));
  };

  const openFullScreen = () => {
    if (images?.length > 0) setIsFullScreen(true);
  };

  const closeFullScreen = () => setIsFullScreen(false);

  return (
    <div className="relative">
      {/* Main Image Container (Fixed Aspect Ratio) */}
      <div
        className={`relative bg-gray-100 rounded-lg overflow-hidden cursor-zoom-in ${aspectRatio}`}
      >
        {images?.length > 0 ? (
          <div className="w-full h-full flex items-center justify-center bg-white p-4">
            <img
              src={images[currentImageIndex]}
              alt="Product"
              className="w-full h-full object-contain"
              onClick={openFullScreen}
            />
          </div>
        ) : (
          <div className="w-full h-full flex items-center justify-center bg-gray-200">
            <span className="text-gray-500">No image available</span>
          </div>
        )}

        {images?.length > 1 && (
          <>
            <button
              onClick={(e) => {
                e.stopPropagation();
                prevImage();
              }}
              className="absolute left-2 top-1/2 -translate-y-1/2 bg-white rounded-full p-2 shadow-md hover:bg-gray-100"
            >
              <FiChevronLeft size={20} />
            </button>
            <button
              onClick={(e) => {
                e.stopPropagation();
                nextImage();
              }}
              className="absolute right-2 top-1/2 -translate-y-1/2 bg-white rounded-full p-2 shadow-md hover:bg-gray-100"
            >
              <FiChevronRight size={20} />
            </button>
          </>
        )}
      </div>

      {/* Thumbnail Navigation */}
      {images?.length > 1 && (
        <div className="flex mt-4 gap-2 overflow-x-auto pb-2">
          {images.map((image, index) => (
            <button
              key={index}
              onClick={() => setCurrentImageIndex(index)}
              className={`flex-shrink-0 ${thumbnailRatio} w-16 border-2 ${
                currentImageIndex === index
                  ? "border-blue-500"
                  : "border-gray-200"
              }`}
            >
              <div className="w-full h-full flex items-center justify-center bg-white p-1">
                <img
                  src={image}
                  alt={`Thumbnail ${index + 1}`}
                  className="w-full h-full object-contain"
                />
              </div>
            </button>
          ))}
        </div>
      )}

      {/* Full Screen Modal */}
      {isFullScreen && (
        <div className="fixed inset-0 z-50 bg-black bg-opacity-90 flex flex-col items-center justify-center p-4">
          <button
            onClick={closeFullScreen}
            className="absolute top-4 right-4 text-white p-2 rounded-full hover:bg-gray-800"
          >
            <FiX size={24} />
          </button>

          <div className="w-full max-w-4xl max-h-[90vh] flex items-center justify-center">
            <div className={`${aspectRatio} w-full`}>
              <div className="w-full h-full flex items-center justify-center p-4">
                <img
                  src={images[currentImageIndex]}
                  alt="Product"
                  className="w-full h-full object-contain"
                />
              </div>
            </div>
          </div>

          {images.length > 1 && (
            <>
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  prevImage();
                }}
                className="absolute left-4 top-1/2 -translate-y-1/2 bg-white bg-opacity-80 rounded-full p-3 shadow-md hover:bg-opacity-100"
              >
                <FiChevronLeft size={24} />
              </button>
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  nextImage();
                }}
                className="absolute right-4 top-1/2 -translate-y-1/2 bg-white bg-opacity-80 rounded-full p-3 shadow-md hover:bg-opacity-100"
              >
                <FiChevronRight size={24} />
              </button>

              <div className="flex mt-4 gap-2 overflow-x-auto pb-2">
                {images.map((image, index) => (
                  <button
                    key={index}
                    onClick={() => setCurrentImageIndex(index)}
                    className={`flex-shrink-0 ${thumbnailRatio} w-16 border-2 ${
                      currentImageIndex === index
                        ? "border-blue-500"
                        : "border-gray-700"
                    }`}
                  >
                    <div className="w-full h-full flex items-center justify-center bg-white p-1">
                      <img
                        src={image}
                        alt={`Thumbnail ${index + 1}`}
                        className="w-full h-full object-contain"
                      />
                    </div>
                  </button>
                ))}
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default ProductImageGallery;

